﻿/*
 * commit id
 * screen message key
 */

export module ApplicationMessageScreen {
  /**
   * (en_US): Required Item.
   */
  export const APP_SCN_00001 = "APP_SCN_00001";
  /**
   * (en_US): Must be {0} characters or above.
   */
  export const APP_SCN_00002 = "APP_SCN_00002";
  /**
   * (en_US): Must be {0} characters or below.
   */
  export const APP_SCN_00003 = "APP_SCN_00003";
  /**
   * (en_US): Must be from {0} to {1} characters.
   */
  export const APP_SCN_00004 = "APP_SCN_00004";
  /**
   * (en_US): Must be an integer no more than {0} digits.
   */
  export const APP_SCN_00005 = "APP_SCN_00005";
  /**
   * (en_US): Must be a number with the integer part being {0} digits or below and the fractional part being {1} digits or below.
   */
  export const APP_SCN_00006 = "APP_SCN_00006";
  /**
   * (en_US): Must be a number {0} or above.
   */
  export const APP_SCN_00007 = "APP_SCN_00007";
  /**
   * (en_US): Must be a number {0} or below.
   */
  export const APP_SCN_00008 = "APP_SCN_00008";
  /**
   * (en_US): Must be a positive number.
   */
  export const APP_SCN_00009 = "APP_SCN_00009";
  /**
   * (en_US): Must be a number 0 or above.
   */
  export const APP_SCN_00010 = "APP_SCN_00010";
  /**
   * (en_US): Must be a negative number.
   */
  export const APP_SCN_00011 = "APP_SCN_00011";
  /**
   * (en_US): Must be a number 0 or below.
   */
  export const APP_SCN_00012 = "APP_SCN_00012";
  /**
   * (en_US): Must be in the format of an email.
   */
  export const APP_SCN_00013 = "APP_SCN_00013";
  /**
   * (en_US): Must be numbers.
   */
  export const APP_SCN_00014 = "APP_SCN_00014";
  /**
   * (en_US): Must be lowercase letters.
   */
  export const APP_SCN_00015 = "APP_SCN_00015";
  /**
   * (en_US): Must be lowercase letters or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00016 = "APP_SCN_00016";
  /**
   * (en_US): Must be uppercase letters.
   */
  export const APP_SCN_00017 = "APP_SCN_00017";
  /**
   * (en_US): Must be uppercase letters or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00018 = "APP_SCN_00018";
  /**
   * (en_US): Must be lowercase or uppercase letters.
   */
  export const APP_SCN_00019 = "APP_SCN_00019";
  /**
   * (en_US): Must be lowercase or uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00020 = "APP_SCN_00020";
  /**
   * (en_US): Must be numbers, lowercase or uppercase letters.
   */
  export const APP_SCN_00021 = "APP_SCN_00021";
  /**
   * (en_US): Must be numbers or lowercase letters.
   */
  export const APP_SCN_00022 = "APP_SCN_00022";
  /**
   * (en_US): Must be numbers or uppercase letters.
   */
  export const APP_SCN_00023 = "APP_SCN_00023";
  /**
   * (en_US): Must be numbers, lowercase or uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00024 = "APP_SCN_00024";
  /**
   * (en_US): Must be numbers, lowercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00025 = "APP_SCN_00025";
  /**
   * (en_US): Must be numbers, uppercase letters, or accepted symbols (white space, #, -, ., /, :, @, _).
   */
  export const APP_SCN_00026 = "APP_SCN_00026";
  /**
   * (en_US): Must be half-width katakana characters.
   */
  export const APP_SCN_00027 = "APP_SCN_00027";
  /**
   * (en_US): Must be full-width characters.
   */
  export const APP_SCN_00028 = "APP_SCN_00028";
  /**
   * (en_US): Must be a date in {0} format.
   */
  export const APP_SCN_00029 = "APP_SCN_00029";
  /**
   * (en_US): Must be numbers, lowercase or uppercase letters, or hyphen.
   */
  export const APP_SCN_00030 = "APP_SCN_00030";
  /**
   * (en_US): Must be numbers, lowercase letters, or hyphen.
   */
  export const APP_SCN_00031 = "APP_SCN_00031";
  /**
   * (en_US): Must be numbers, uppercase letters, or hyphen.
   */
  export const APP_SCN_00032 = "APP_SCN_00032";
  /**
   * (en_US): Are you sure you want to exit without saving?
   */
  export const APP_SCN_00033 = "APP_SCN_00033";
  /**
   * (en_US): Comments with no Action selected will be discarded. Do you want to continue?
   */
  export const APP_SCN_00034 = "APP_SCN_00034";
  /**
   * (en_US): No rows are selected.
   */
  export const APP_SCN_00035 = "APP_SCN_00035";
  /**
   * (en_US): Must be distinct values.
   */
  export const APP_SCN_00036 = "APP_SCN_00036";
  /**
   * (en_US): Must exist in Component Master.
   */
  export const APP_SCN_00037 = "APP_SCN_00037";
  /**
   * (en_US): Unable to delete latest IF definition snapshot.
   */
  export const APP_SCN_00038 = "APP_SCN_00038";
  /**
   * (en_US): At least one item is required.
   */
  export const APP_SCN_00039 = "APP_SCN_00039";
  /**
   * (en_US): Must not be duplicated.
   */
  export const APP_SCN_00040 = "APP_SCN_00040";
  /**
   * (en_US): Can not {0} for records with status other than {1}.
   */
  export const APP_SCN_00041 = "APP_SCN_00041";
  /**
   * (en_US): Incorrect type code.
   */
  export const APP_SCN_00042 = "APP_SCN_00042";
  /**
   * (en_US): Deployment requests on {0} will be outside of operating time. Do you want to continue anyway?
   */
  export const APP_SCN_00043 = "APP_SCN_00043";
  /**
   * (en_US): Saved successfully.
   */
  export const APP_SCN_00044 = "APP_SCN_00044";
  /**
   * (en_US): Do you want to save your changes?
   */
  export const APP_SCN_00045 = "APP_SCN_00045";
  /**
   * (en_US): Switch IE Maintenance mode?
   */
  export const APP_SCN_00046 = "APP_SCN_00046";
  /**
   * (en_US): Couldn't get project data.
   */
  export const APP_SCN_00047 = "APP_SCN_00047";
  /**
   * (en_US): The requested partner code is already in use.
   */
  export const APP_SCN_00048 = "APP_SCN_00048";
  /**
   * (en_US): Must match the regex {0}.
   */
  export const APP_SCN_00049 = "APP_SCN_00049";
  /**
   * (en_US): Chain type still exists.
   */
  export const APP_SCN_00050 = "APP_SCN_00050";
  /**
   * (en_US): Component project is still in progress.
   */
  export const APP_SCN_00051 = "APP_SCN_00051";
  /**
   * (en_US): IF project is still in progress.
   */
  export const APP_SCN_00052 = "APP_SCN_00052";
  /**
   * (en_US): Select Yes/No for all [Necessity] items.
   */
  export const APP_SCN_00053 = "APP_SCN_00053";
  /**
   * (en_US): Specified protocol does not exist in master.
   */
  export const APP_SCN_00054 = "APP_SCN_00054";
  /**
   * (en_US): Deployment request already exists.
   */
  export const APP_SCN_00055 = "APP_SCN_00055";
  /**
   * (en_US): Interface Layout file(s) for File ID(s) {0} do not exist. Please upload layout files before prd deployment request.
   */
  export const APP_SCN_00056 = "APP_SCN_00056";
  /**
   * (en_US): Interface Layout file(s) for File ID(s) {0} do not exist. Please upload layout files before prd deployment request.
   */
  export const APP_SCN_00057 = "APP_SCN_00057";
  /**
   * (en_US): Cannot create a deployment request because the component is not ready.
   */
  export const APP_SCN_00058 = "APP_SCN_00058";
  /**
   * (en_US): Cannot revert deployment request.
   */
  export const APP_SCN_00059 = "APP_SCN_00059";
  /**
   * (en_US): {0} is currently outside of operating time and cannot create a deployment request.
   */
  export const APP_SCN_00060 = "APP_SCN_00060";
  /**
   * (en_US): Cannot get {0}.
   */
  export const APP_SCN_00061 = "APP_SCN_00061";
  /**
   * (en_US): Illegal state transition.
   */
  export const APP_SCN_00062 = "APP_SCN_00062";
  /**
   * (en_US): Cannot set these protocol combinations.
   */
  export const APP_SCN_00063 = "APP_SCN_00063";
  /**
   * (en_US): Root component cannot be deleted because related components still exist.
   */
  export const APP_SCN_00064 = "APP_SCN_00064";
  /**
   * (en_US): Cannot change the status of a closed project.
   */
  export const APP_SCN_00065 = "APP_SCN_00065";
  /**
   * (en_US): The status cannot be changed from \"Requirement Design\" to \"Complete\".
   */
  export const APP_SCN_00066 = "APP_SCN_00066";
  /**
   * (en_US): You can set the IFD deployable flag only for projects that are in progress.
   */
  export const APP_SCN_00067 = "APP_SCN_00067";
  /**
   * (en_US): \"IF Can Deployment\" for projects not in progress cannot be changed.
   */
  export const APP_SCN_00068 = "APP_SCN_00068";
  /**
   * (en_US): Cannot execute because there is a project in progress with the same component and protocol.
   */
  export const APP_SCN_00069 = "APP_SCN_00069";
  /**
   * (en_US): To run your project, you must set a staging and production deployment planning date.
   */
  export const APP_SCN_00070 = "APP_SCN_00070";
  /**
   * (en_US): Cannot complete the project because there are tickets that have not been closed.
   */
  export const APP_SCN_00071 = "APP_SCN_00071";
  /**
   * (en_US): The staging and production planned deployment dates must be set before the earliest planned deployment date of the associated IF project.
   */
  export const APP_SCN_00072 = "APP_SCN_00072";
  /**
   * (en_US): Cannot set IF Can Deploy since the component has never been deployed.
   */
  export const APP_SCN_00073 = "APP_SCN_00073";
  /**
   * (en_US): Event Type is divided for the event group.
   */
  export const APP_SCN_00074 = "APP_SCN_00074";
  /**
   * (en_US): {0} team stakeholders are not registered in the component project.
   */
  export const APP_SCN_00075 = "APP_SCN_00075";
  /**
   * (en_US): Required data {0} is not in {1} master.
   */
  export const APP_SCN_00076 = "APP_SCN_00076";
  /**
   * (en_US): Combination of team and role is invalid.
   */
  export const APP_SCN_00077 = "APP_SCN_00077";
  /**
   * (en_US): Combination of user and selected role is invalid.
   */
  export const APP_SCN_00078 = "APP_SCN_00078";
  /**
   * (en_US): There must be only one user with primary.
   */
  export const APP_SCN_00079 = "APP_SCN_00079";
  /**
   * (en_US): Select a User.
   */
  export const APP_SCN_00080 = "APP_SCN_00080";
  /**
   * (en_US): {0} the project.
   */
  export const APP_SCN_00081 = "APP_SCN_00081";
  /**
   * (en_US): Requests a quote from PIC of IF Requirement.
   */
  export const APP_SCN_00082 = "APP_SCN_00082";
  /**
   * (en_US): Requests DIP Manager to confirm the quotation results.
   */
  export const APP_SCN_00083 = "APP_SCN_00083";
  /**
   * (en_US): Reply to project manager with the result of the quotation. If you reject, please write the reason for rejection in the comment field below.
   */
  export const APP_SCN_00084 = "APP_SCN_00084";
  /**
   * (en_US): Request DIP Manager to approve the project plan.
   */
  export const APP_SCN_00085 = "APP_SCN_00085";
  /**
   * (en_US): Reply to Project Owner with the result of the project plan. If you reject, please write the reason for rejection in the comment field below.
   */
  export const APP_SCN_00086 = "APP_SCN_00086";
  /**
   * (en_US): {0} IF requirements.
   */
  export const APP_SCN_00087 = "APP_SCN_00087";
  /**
   * (en_US): Withdraw the project plan approval request. Please enter the reason in the comment field below.
   */
  export const APP_SCN_00088 = "APP_SCN_00088";
  /**
   * (en_US): Returns the project plan to the status of Estimation In Progress. Running projects will be pended.
   */
  export const APP_SCN_00089 = "APP_SCN_00089";
  /**
   * (en_US): This project has been registered. IE team will contact you for consultation.
   */
  export const APP_SCN_00090 = "APP_SCN_00090";
  /**
   * (en_US): The registered PIC of IF Requirement have been notified of instructions to define requirements and estimate the cost.
   */
  export const APP_SCN_00091 = "APP_SCN_00091";
  /**
   * (en_US): A request for confirmation of the contents of the quotation has been sent to the DIP Manager. DIP Manager will reply to Project Owner with the results of the quotation.
   */
  export const APP_SCN_00092 = "APP_SCN_00092";
  /**
   * (en_US): The quotation result has been replied to Project Owner. Project Owner will starts budget acquisition.
   */
  export const APP_SCN_00093 = "APP_SCN_00093";
  /**
   * (en_US): Re-Estimation has been requested to PIC of IF Requirement.
   */
  export const APP_SCN_00094 = "APP_SCN_00094";
  /**
   * (en_US): Requesting approval of the project plan from the DIP Manager. Once approved by the DIP Manager, the project plan will be complete.
   */
  export const APP_SCN_00095 = "APP_SCN_00095";
  /**
   * (en_US): The project plan is now complete. A notification has been sent to the PIC of IF Requirement, with instructions to register the details of the IF requirements.
   */
  export const APP_SCN_00096 = "APP_SCN_00096";
  /**
   * (en_US): Request for approval of project plan has been rejected.
   */
  export const APP_SCN_00097 = "APP_SCN_00097";
  /**
   * (en_US): IF requirements definition have been determined and stakeholders notified.
   */
  export const APP_SCN_00098 = "APP_SCN_00098";
  /**
   * (en_US): Project has been started.
   */
  export const APP_SCN_00099 = "APP_SCN_00099";
  /**
   * (en_US): Project has been closed.
   */
  export const APP_SCN_00100 = "APP_SCN_00100";
  /**
   * (en_US): Request for approval of project plan has been withdrawn.
   */
  export const APP_SCN_00101 = "APP_SCN_00101";
  /**
   * (en_US): The status of the project plan has been changed back to Estimation In Progress.
   */
  export const APP_SCN_00102 = "APP_SCN_00102";
  /**
   * (en_US): IF requirement definition has been determined again, and the pending project has been resumed.
   */
  export const APP_SCN_00103 = "APP_SCN_00103";
  /**
   * (en_US): This project has been declared cancelled.
   */
  export const APP_SCN_00104 = "APP_SCN_00104";
  /**
   * (en_US): Status has changed. You can now edit the IF requirement.
   */
  export const APP_SCN_00105 = "APP_SCN_00105";
  /**
   * (en_US): End date must be equal or later than Start date.
   */
  export const APP_SCN_00106 = "APP_SCN_00106";
  /**
   * (en_US): No new roles or teams can be added after the \"Project In Progress\" status.
   */
  export const APP_SCN_00107 = "APP_SCN_00107";
  /**
   * (en_US): Primary user cannot be deleted after the \"Project In Progress\" status.
   */
  export const APP_SCN_00108 = "APP_SCN_00108";
  /**
   * (en_US): Cannot revert the status to waiting for project execution because there is a ticket in progress.
   */
  export const APP_SCN_00109 = "APP_SCN_00109";
  /**
   * (en_US): {0} already exists.
   */
  export const APP_SCN_00110 = "APP_SCN_00110";
  /**
   * (en_US): {0} cannot be deleted because it is being used by a running Project.
   */
  export const APP_SCN_00111 = "APP_SCN_00111";
  /**
   * (en_US): {0} cannot be deleted because it is being used in a production environment.
   */
  export const APP_SCN_00112 = "APP_SCN_00112";
  /**
   * (en_US): When {0} is enabled, protocol {1} for {2} cannot be selected.
   */
  export const APP_SCN_00113 = "APP_SCN_00113";
  /**
   * (en_US): When Use Assumed Role is enalbled, the outbound protocol object storage can only be selected in AWS.
   */
  export const APP_SCN_00114 = "APP_SCN_00114";
  /**
   * (en_US): IF start method {0} cannot be selected for protocol {1}.
   */
  export const APP_SCN_00115 = "APP_SCN_00115";
  /**
   * (en_US): When the EDI Usage is enabled, IF start method {0} cannot be selected for protocol object storage.
   */
  export const APP_SCN_00116 = "APP_SCN_00116";
  /**
   * (en_US): {0} is required item.
   */
  export const APP_SCN_00117 = "APP_SCN_00117";
  /**
   * (en_US): The status transition is unsupported.
   */
  export const APP_SCN_00118 = "APP_SCN_00118";
  /**
   * (en_US): Do you want to issue a File ID? Once issued, you will need to upload the layout file.
   */
  export const APP_SCN_00119 = "APP_SCN_00119";
  /**
   * (en_US): Must be Y or N.
   */
  export const APP_SCN_00120 = "APP_SCN_00120";
  /**
   * (en_US): The required component project is not linked.
   */
  export const APP_SCN_00121 = "APP_SCN_00121";
  /**
   * (en_US): The same conversion rule already exist. Environment ID From: {0}, Environment ID To: {1}, Component ID: {2}, Boundary ID: {3}, Interface Item Group Number: {4}, Interface Item Number: {5} IF Definition Conversion Rule Type Code: {6}
   */
  export const APP_SCN_00122 = "APP_SCN_00122";
  /**
   * (en_US): The same conversion rule already exist. Environment ID From: {0}, Environment ID To: {1},Component Attribute Number: {2}, Component ID: {3}
   */
  export const APP_SCN_00123 = "APP_SCN_00123";
  /**
   * (en_US): Cannot create duplicate environment copy conversion rules.
   */
  export const APP_SCN_00124 = "APP_SCN_00124";
  /**
   * (en_US): {0} is not found.
   */
  export const APP_SCN_00125 = "APP_SCN_00125";
  /**
   * (en_US): Retrieves the value of the item associated with the specified Key from the DB. This will overwrite the edited value.
   */
  export const APP_SCN_00126 = "APP_SCN_00126";
  /**
   * (en_US): Rows marked \"Cancel\" will be deleted.
   */
  export const APP_SCN_00127 = "APP_SCN_00127";
  /**
   * (en_US): Some lines will be cancel or purge status.
   */
  export const APP_SCN_00128 = "APP_SCN_00128";
  /**
   * (en_US): Must not be set.
   */
  export const APP_SCN_00129 = "APP_SCN_00129";
  /**
   * (en_US): Cannot be canceled environment copy deployment requests with a status other than deployment pending.
   */
  export const APP_SCN_00130 = "APP_SCN_00130";
  /**
   * (en_US): Definition set versions of environments {0} and {1} are incompatible.
   */
  export const APP_SCN_00131 = "APP_SCN_00131";
  /**
   * (en_US): Environment copy deployment to environment {0} is in progress.
   */
  export const APP_SCN_00132 = "APP_SCN_00132";
  /**
   * (en_US): Save the review of the selected deployment request?
   */
  export const APP_SCN_00133 = "APP_SCN_00133";
  /**
   * (en_US): Withdraw the selected deployment request?
   */
  export const APP_SCN_00134 = "APP_SCN_00134";
  /**
   * (en_US): Retry the selected deployment request?
   */
  export const APP_SCN_00135 = "APP_SCN_00135";
  /**
   * (en_US): Revert the selected deployment request?
   */
  export const APP_SCN_00136 = "APP_SCN_00136";
  /**
   * (en_US): Required stakeholder is not registered.
   */
  export const APP_SCN_00137 = "APP_SCN_00137";
  /**
   * (en_US): Data Kind Id must be (numbers, lowercase letters or uppercase letters) and 7 digit,  must not start from letter, and must not be only numbers.
   */
  export const APP_SCN_00138 = "APP_SCN_00138";
  /**
   * (en_US): Failed to display per-line error messages (invalid index).
   */
  export const APP_SCN_00139 = "APP_SCN_00139";
  /**
   * (en_US): A record with the same Data Kind Id must have the Base File flag set to Yes.
   */
  export const APP_SCN_00140 = "APP_SCN_00140";
  /**
   * (en_US): {0} does not exist.
   */
  export const APP_SCN_00141 = "APP_SCN_00141";
  /**
   * (en_US): Data Kind ID and Component ID are required to issue a File ID.
   */
  export const APP_SCN_00142 = "APP_SCN_00142";
  /**
   * (en_US): Cannot be withdrawn because deployment status is other than \"Waiting Request Plan\" or \"Deployed\".
   */
  export const APP_SCN_00143 = "APP_SCN_00143";
  /**
   * (en_US): Cannot be changed because the required tasks selection has been completed.
   */
  export const APP_SCN_00144 = "APP_SCN_00144";
  /**
   * (en_US): There is no IF with {0} waiting to deploy as an attribute value
   */
  export const APP_SCN_00145 = "APP_SCN_00145";
  /**
   * (en_US): There are no changes to the data.
   */
  export const APP_SCN_00146 = "APP_SCN_00146";
  /**
   * (en_US): Cannot be deleted because the component has valid {0}.
   */
  export const APP_SCN_00147 = "APP_SCN_00147";
  /**
   * (en_US): Partner code must be 8 half-width digits, and first digit must be 1 or 2.
   */
  export const APP_SCN_00148 = "APP_SCN_00148";
  /**
   * (en_US): Cannot create component project with a specified protocol due to lack of IE Maintenance authority.
   */
  export const APP_SCN_00149 = "APP_SCN_00149";
  /**
   * (en_US): Cannot be determined again because deployment is in progress.
   */
  export const APP_SCN_00150 = "APP_SCN_00150";
  /**
   * (en_US): Cannot change Cancel Requirement Type because the IF requirement has already been deployed in production environment.
   */
  export const APP_SCN_00151 = "APP_SCN_00151";
  /**
   * (en_US): Cannot set the deployment datetime to a datetime in the past.
   */
  export const APP_SCN_00152 = "APP_SCN_00152";
  /**
   * (en_US): Cannot create deployment request in environments other than production and staging.
   */
  export const APP_SCN_00153 = "APP_SCN_00153";
  /**
   * (en_US): Duplicated with the following projects. {0}
   */
  export const APP_SCN_00154 = "APP_SCN_00154";
  /**
   * (en_US): Data Kind Id {0} has already been broadcast.
   */
  export const APP_SCN_00155 = "APP_SCN_00155";
  /**
   * (en_US): There is a problem with the IF requirement. Check the IF requirement list.
   */
  export const APP_SCN_00156 = "APP_SCN_00156";
  /**
   * (en_US): Duplicate Deployed IDs detected. Check the IF requirement list.
   */
  export const APP_SCN_00157 = "APP_SCN_00157";
  /**
   * (en_US): Staging deployment planned date for project execution is required.
   */
  export const APP_SCN_00158 = "APP_SCN_00158";
  /**
   * (en_US): Are you sure you want to {0} the deployment request?
   */
  export const APP_SCN_00159 = "APP_SCN_00159";
  /**
   * (en_US): Cannot deploy component name because there is no EDH protocol linked to the component.
   */
  export const APP_SCN_00160 = "APP_SCN_00160";
  /**
   * (en_US): Component name waiting to be changed must be set.
   */
  export const APP_SCN_00161 = "APP_SCN_00161";
  /**
   * (en_US): A project started by IE maintenance cannot be reverted to the Component Project Requirements Design state.
   */
  export const APP_SCN_00162 = "APP_SCN_00162";
  /**
   * (en_US): The attribute cannot be edited because it is duplicated in another project.
   */
  export const APP_SCN_00163 = "APP_SCN_00163";
  /**
   * (en_US): A ticket with an unclear deployment status has been detected. Check the interface list.
   */
  export const APP_SCN_00164 = "APP_SCN_00164";
  /**
   * (en_US): There is one or more rows that failed to save.
   */
  export const APP_SCN_00165 = "APP_SCN_00165";
  /**
   * (en_US): Rows with duplicate issues are selected.These cannot be deployed.
   */
  export const APP_SCN_00166 = "APP_SCN_00166";
  /**
   * (en_US): File size is too large. Must be {0} MB or below.
   */
  export const APP_SCN_00167 = "APP_SCN_00167";
  /**
   * (en_US): Are you sure you want to discard the deployment request specified in the checkbox?
   */
  export const APP_SCN_00168 = "APP_SCN_00168";
  /**
   * (en_US): Are you sure you want to  {0} the {1}?
   */
  export const APP_SCN_00169 = "APP_SCN_00169";
  /**
   * (en_US): Are you sure you want to permanently delete this data?
   */
  export const APP_SCN_00170 = "APP_SCN_00170";
  /**
   * (en_US): Are you sure you want to cancel the request waiting to be copied?
   */
  export const APP_SCN_00171 = "APP_SCN_00171";
  /**
   * (en_US): A user with the same team code and role code already exists.
   */
  export const APP_SCN_00172 = "APP_SCN_00172";
  /**
   * (en_US): The user who created the deployment request cannot approve or reject it.
   */
  export const APP_SCN_00173 = "APP_SCN_00173";
  /**
   * (en_US): IE Maintenance IF attributes cannot be re-entered.
   */
  export const APP_SCN_00174 = "APP_SCN_00174";
  /**
   * (en_US): IE Maintenance IF attributes cannot be dimissed.
   */
  export const APP_SCN_00175 = "APP_SCN_00175";
  /**
   * (en_US): Showing {0} of {1} matches for your search. Please narrow it down further.
   */
  export const APP_SCN_00176 = "APP_SCN_00176";
  /**
   * (en_US): Requested an IF design review. Please wait until the review is complete.
   */
  export const APP_SCN_00177 = "APP_SCN_00177";
  /**
   * (en_US): Review completed.
   */
  export const APP_SCN_00178 = "APP_SCN_00178";
  /**
   * (en_US): Important!\nIt will register a new file layout and number a new File ID.\nPlease confirm existing file layouts, and enter OK button only if you can't use existing one.\nOnce you enter it, please put a file layout document on SharePoint below.\n　\nFile layout document naming rule :  Interface_Layout_Definition_{0}.xlsx\n　\nSharePoint location : \n<G2M>(ext) [Ariake2.0]002_IF_Platform > 50.VariousLists > InterfaceLayoutDocuments > {1} > {2}
   */
  export const APP_SCN_00179 = "APP_SCN_00179";
  /**
   * (en_US): Discard unsaved changes on all rows. Retrieves the value of the item associated with the specified Key from the DB. This will overwrite the edited value. Do you want to continue?
   */
  export const APP_SCN_00180 = "APP_SCN_00180";
  /**
   * (en_US): The request contains multiple records for the same user, team code and role code.
   */
  export const APP_SCN_00181 = "APP_SCN_00181";
  /**
   * (en_US): Input data is valid.
   */
  export const APP_SCN_00182 = "APP_SCN_00182";
  /**
   * (en_US): Cancel Requirement Type cannot be saved as Cancel or Purge because the IF Requirement has never been saved.
   */
  export const APP_SCN_00183 = "APP_SCN_00183";
  /**
   * (en_US): There are IF definitions where multiple Inbound IDs are tied to a single Interdomain ID, which cannot be modified in a normal project.
   */
  export const APP_SCN_00184 = "APP_SCN_00184";
  /**
   * (en_US): You cannot edit because {0} has already been changed.
   */
  export const APP_SCN_00185 = "APP_SCN_00185";
  /**
   * (en_US): Cannot bulk paste this item, because this change would modify other cells.
   */
  export const APP_SCN_00186 = "APP_SCN_00186";
  /**
   * (en_US): The project cannot be completed because the {0} IF can deploy flag is No.
   */
  export const APP_SCN_00187 = "APP_SCN_00187";
  /**
   * (en_US): Must be numbers, uppercase letters, or accepted symbols (_).
   */
  export const APP_SCN_00188 = "APP_SCN_00188";
  /**
   * (en_US): Cannot update the status of projects that have the same component ID and protocol simultaneously from 'Component Project Requirement Design' to 'Project In Progress'.
   */
  export const APP_SCN_00189 = "APP_SCN_00189";
  /**
   * (en_US): Cannot create a deployment request for an undeployed DataKindName. Please uncheck the row with Deployed In EDH set to No.
   */
  export const APP_SCN_00190 = "APP_SCN_00190";
  /**
   * (en_US): Cannot apply changes DataKindName used in a deployed IF. Please uncheck the row with Deployed In EDH set to Yes.
   */
  export const APP_SCN_00191 = "APP_SCN_00191";
  /**
   * (en_US): Interface Requirement Type is incorrect.{0}
   */
  export const APP_SCN_00192 = "APP_SCN_00192";
  /**
   * (en_US): If the Base File Flag is \"Yes\", the Fork Reason must be \"Origin\".
   */
  export const APP_SCN_00193 = "APP_SCN_00193";
  /**
   * (en_US): If the Base File Flag is \"No\", the Fork Reason must be something other than \"Origin\".
   */
  export const APP_SCN_00194 = "APP_SCN_00194";
  /**
   * (en_US): Cannot set a File Id when the Data Kind ID does not contain any characters.
   */
  export const APP_SCN_00195 = "APP_SCN_00195";
  /**
   * (en_US): The file ID must consist of seven alphanumeric characters, followed by a \"-\" and three numbers or four alphanumeric characters, followed by a \"-\" and three numbers.
   */
  export const APP_SCN_00196 = "APP_SCN_00196";
  /**
   * (en_US): The file ID already exists.
   */
  export const APP_SCN_00197 = "APP_SCN_00197";
  /**
   * (en_US): Cannot set the same File Id.
   */
  export const APP_SCN_00198 = "APP_SCN_00198";
  /**
   * (en_US): If metaOnlyFlag is Yes, {0} cannot be updated.
   */
  export const APP_SCN_00199 = "APP_SCN_00199";
  /**
   * (en_US): If metaOnlyFlag is Yes, new IF routes cannot be added.
   */
  export const APP_SCN_00200 = "APP_SCN_00200";
  /**
   * (en_US): metaOnlyFlag cannot be entered with requirement {0}.
   */
  export const APP_SCN_00201 = "APP_SCN_00201";
  /**
   * (en_US): If  metaOnlyFlag is Yes, the only allowed requirement types are Update/Update, Update/NoChange, and NoChange/Update.
   */
  export const APP_SCN_00202 = "APP_SCN_00202";
  /**
   * (en_US): Interface Layout file for File ID {0} do not exist. Please upload layout files before prd deployment request.
   */
  export const APP_SCN_00203 = "APP_SCN_00203";
  /**
   * (en_US): Only one primary role allowed.
   */
  export const APP_SCN_00204 = "APP_SCN_00204";
  /**
   * (en_US): Coverage Code for roles DIP Manager and IE Maintenance must be 'JEDI'.
   */
  export const APP_SCN_00205 = "APP_SCN_00205";
  /**
   * (en_US): Coverage Code 'JEDI' is only allowed for roles DIP Manager and IE Maintenance.
   */
  export const APP_SCN_00206 = "APP_SCN_00206";
  /**
   * (en_US): Coverage Code must be 'JEDI' or DIP.
   */
  export const APP_SCN_00207 = "APP_SCN_00207";
  /**
   * (en_US): A record with the following key values already exists, or the key is duplicated: {0}.
   */
  export const APP_SCN_00208 = "APP_SCN_00208";
  /**
   * (en_US): There is no data to output.
   */
  export const APP_SCN_00210 = "APP_SCN_00210";
}
